import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";

const useAllSettings = () => {
  const [selectedMenuTab, setSelectedMenuTab] = useState("configuration");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const menuTab = location.state?.menuTab;

    if (menuTab && menuTab !== selectedMenuTab) {
      setSelectedMenuTab(menuTab);

      if (menuTab === "configuration") {
        navigate(pathConstants.INVENTORY_PRINTER_CONFIGURATION, {
          replace: true,
          state: { menuTab: "configuration" },
        });
      } else if (menuTab === "customization") {
        navigate(pathConstants.APP_RECEIPT_CUSTOMIZATION, {
          replace: true,
          state: { menuTab: "customization" },
        });
      }
    }
  }, [location.state?.menuTab]);

  return {
    selectedMenuTab,
    setSelectedMenuTab,
    navigate,
    location,
  };
};

export default useAllSettings;
